import { conexaoDB } from "./db";

async function saveDadosBase(data) {
  const db = await conexaoDB();
  const objectStore = db.transaction(["base"], "readwrite").objectStore("base");
  objectStore.clear();
  objectStore.add(data);
}

async function getDadosBaseDB() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db.transaction(["base"]).objectStore("base").getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

export { saveDadosBase, getDadosBaseDB };
